import {initAccordionWithImg} from "./custom/accordionWithImg";
import {initAccordionExtended} from "./custom/accordionExtended";
import {initDcImageGallery} from "./custom/dcImageGallery";
import {initBugBuster} from "./custom/bugBuster";
import {initMobileMenu} from "./custom/mobileMenu";
import {initHeaderPanel} from "./custom/headerPanel";
import {initSubHeaderMenu} from "./custom/subHeaderMenu";
import {initProjectSlider} from "./custom/projectSlider";
import {initProfileSlider} from "./custom/profileSlider";
import {initSlideTextslider} from "./custom/slideTextslider";
import hoverintent from "cronus-theme/default/global/js/hoverintent";
import {isTouchDevice} from "cronus-theme/default/global/js/touchDevice";
import {initContentTabs} from "./custom/contentTabs";
import {initNewsSlider} from "./custom/newsSlider";
import {initScrollingMarquee} from "./custom/scrollingMarquee";
import {initCustomersMarquee} from "./custom/customersMarquee";
import {loadHubspotForm, initHubspotForms} from "./custom/loadHubspotForm";
import {initGalleryCarousel} from "./custom/galleryCarousel";
import {initGalleryReels} from "./custom/galleryReels";
import {initImgTextColumnsSlider} from "./custom/imgTextColumnsSlider";
import {initFilterSolutions} from "./custom/filterSolutions";
import {initLiveFilterCollection} from "./custom/collectionLiveFilter";
import {initLenis} from "./custom/lenis";
import {initslideSpecialEvents} from "./custom/slideSpecialEvents";
import initTypingList from "./custom/typingList";
import {initFlyingIconsParallax, initHeroAboutUsParallax, initHeroAboutUsAnimations} from "./custom/parallax";
import {initPreviewVideo} from "./custom/previewVideo";
import {initAreaWheel} from "./custom/areaWheel";
import {initStackingSlider} from "./custom/stackingSlider";
import {initTabsTextSlider} from "./custom/tabsTextSlider";
import {initGlossar} from "./custom/glossar";
import {initSlideshows} from "./custom/slideshow";
import {initSalaryCalculator} from "./custom/salaryCalculator";
import {stickyHeader} from "cronus-theme/default/global/js/stickyheader";
import {triggerDCCopyLink} from "./custom/copyToClipboard";
import {initTextHighBullets} from "./custom/textHighBullets";
import {initDcBanner} from "./custom/dcBanner";
import {initHeroProjectsPreview} from "./custom/heroProjectsPreview";
import {initJobsCounter} from "./custom/jobsCounter";
import {triggerCopyLink} from "cronus-theme/default/global/js/copyToClipboard";
import {initHubspotChatDelay} from "./custom/hubspotChat";
import {initRequestBannerModal} from "./custom/requestBannerModal";
import {initScrollytelling} from "./custom/scrollytelling";
import {initHistory} from "./custom/history";
import {initKununuSlider} from "./custom/kununuSlider";
import {initHeroWithGallery} from "./custom/heroWithGallery";
import {initPricePackages} from "./custom/pricePackages";
import {initLazyVideos} from "./custom/lazyVideo";
import {initPromoBarModal} from "./custom/promoBarModal";
import {initElfsightLanguage} from "./custom/elfsightLanguage";
import {initEventbriteConsent} from "./custom/eventbriteConsent";

// Muss vor der Elfsight-Initialisierung laufen, deshalb nicht im load-Handler.
initElfsightLanguage();

document.addEventListener("DOMContentLoaded", () => {
    const subHeader = document.querySelector('.dcSubHeader');
    if (subHeader) {
        window.GLOBALS = window.GLOBALS || {};
        window.GLOBALS.offsetTopJumpmarks = (window.GLOBALS.offsetTopJumpmarks || 0) + subHeader.offsetHeight;
    }
});

window.addEventListener("load", (event) => {
    initLenis();
    initAccordionWithImg();
    initAccordionExtended();
    initDcImageGallery();
    initBugBuster();
    initJobsCounter();
    initMobileMenu();
    initHeaderPanel();
    initSubHeaderMenu();
    initProjectSlider();
    initProfileSlider();
    initSlideTextslider();
    initContentTabs();
    initNewsSlider();
    initScrollingMarquee();
    initCustomersMarquee();
    initGalleryCarousel();
    initGalleryReels();
    initImgTextColumnsSlider();
    initFilterSolutions();
    initslideSpecialEvents();
    initTypingList();
    initFlyingIconsParallax();
    initHeroAboutUsParallax();
    initHeroAboutUsAnimations();
    initPreviewVideo();
    initAreaWheel();
    initStackingSlider();
    initTabsTextSlider();
    initGlossar();
    initSlideshows();
    initSalaryCalculator();
    initTextHighBullets();
    initDcBanner();
    //initHeroServices();
    initHeroProjectsPreview();
    triggerDCCopyLink();
    triggerCopyLink();
    initRequestBannerModal();
    initHubspotForms();
    initHubspotChatDelay();
    initScrollytelling();
    initHistory();
    initKununuSlider();
    initHeroWithGallery();
    initPricePackages();
    initLazyVideos();
    initPromoBarModal();
    initEventbriteConsent();

    const jobsList = document.querySelector('.dcJobsList');
    if (jobsList) initLiveFilterCollection(jobsList);

    stickyHeader(document.querySelector('.dcSubHeader'));

    for (const el of document.querySelectorAll('.js-hoverintent')) {
        hoverintent(el);
    }

    if(!isTouchDevice()){
        // Muss zur width-Transition der Kacheln aus _softwareSolutions.scss passen.
        const cardExpandDuration = 300;
        const softwareSolutionsDesktop = window.matchMedia('(min-width: 1250px)');

        const resetSoftwareSolutionsSummary = (summary) => {
            summary.style.transition = '';
            summary.style.height = '';
            summary.style.opacity = '';
            summary.style.marginBottom = '';
        };

        for (const el of document.querySelectorAll('.softwareSolutions__grid > li')) {
            const summary = el.querySelector('.softwareSolutionsItem__summary');
            let enterTimeout;

            hoverintent(el, 200,
                () => {
                    if (!summary) return;
                    clearTimeout(enterTimeout);

                    // Unterhalb von lg ist der Text dauerhaft sichtbar, dann darf
                    // der Hover ihn nicht einklappen.
                    if (!softwareSolutionsDesktop.matches) {
                        resetSoftwareSolutionsSummary(summary);
                        return;
                    }

                    // Erst einblenden, wenn die Kachel ihre volle Breite erreicht
                    // hat. Wird vorher gemessen, gilt die Hoehe der schmalen Kachel
                    // (mehr Zeilenumbrueche) und der Text springt. (#230971)
                    enterTimeout = setTimeout(() => {
                        summary.style.transition = 'none';
                        summary.style.height = 'auto';
                        const targetHeight = summary.offsetHeight;
                        summary.style.height = '0px';
                        summary.offsetHeight; // force reflow

                        // Hoehe und Deckkraft laufen gemeinsam: Der Text blendet ein
                        // und schiebt dabei den Pfeil nach unten.
                        summary.style.transition = 'height 0.3s linear, opacity 0.3s linear, margin-bottom 0.3s linear';
                        summary.style.height = targetHeight + 'px';
                        summary.style.opacity = '1';
                        summary.style.marginBottom = '16px';
                    }, cardExpandDuration);
                },
                () => {
                    if (!summary) return;
                    clearTimeout(enterTimeout);

                    if (!softwareSolutionsDesktop.matches) {
                        resetSoftwareSolutionsSummary(summary);
                        return;
                    }

                    summary.style.transition = 'height 0.3s linear, opacity 0.3s linear, margin-bottom 0.3s linear';
                    summary.style.height = '0px';
                    summary.style.opacity = '0';
                    summary.style.marginBottom = '0px';
                }
            );
        }
    }

    window.loadHubspotForm = (...args) => loadHubspotForm(...args);
});